import React, { useEffect, useMemo } from 'react';
import { esPagina, existePagina, useNameUrl, getDataUrl } from './utils';
import {
  actionTypes,
  useDispatchNotifications,
} from '../../contexts/notificationsContext';
import { useSetPage } from '../../contexts/pageContext';
import { useMesa } from '../../contexts/viewContext';
/**
 * Se encarga de hacer fetch de los datos necesarios y cambiar el estado de la aplicación
 * según estemos en una página de resultados e inicio
 */

const getDataUrls = ({
  id,
  eleccion,
  page,
  nomenclator,
  idHistorico,
  parentLevel,
  mesa,
}) => {
  let dataUrls;
  if (page === 'inicio') {
    const elecciones = nomenclator.ambitos[eleccion][id].r
      .slice(0, -1)
      .map((x, i) => ({
        hayEleccion: x !== -1,
        i,
      }))
      .filter(({ hayEleccion }) => hayEleccion)
      .map(({ i }) => i + 1);
    const orderedElec = nomenclator.ordAmbitos.filter(x =>
      elecciones.includes(Number(x))
    );

    dataUrls = orderedElec.map(eleccion =>
      getDataUrl({
        id,
        eleccion,
        page,
        nomenclator,
        idHistorico,
        parentLevel,
      })
    );
  } else {
    dataUrls = getDataUrl({
      id,
      eleccion,
      page,
      nomenclator,
      idHistorico,
      parentLevel,
      mesa,
    });
  }
  return dataUrls;
};
const DataFetcher = ({
  nomenclator,
  eleccion,
  id,
  pathname,
  history,
  page,
  idHistorico,
  parentLevel,
}) => {
  const isValid = esPagina(id) && existePagina(id, eleccion, nomenclator);
  const { mesa } = useMesa();
  useNameUrl({
    id,
    eleccion,
    nomenclator,
    isValid,
    history,
    pathname,
    page,
    idHistorico,
    parentLevel,
    mesa,
  });

  const initialUrlInfo = React.useMemo(
    () => ({
      id,
      eleccion,
      page,
      idHistorico,
      parentLevel,
      mesa,
    }),
    [id, eleccion, page, idHistorico, parentLevel, mesa]
  );

  const dataUrls = useMemo(
    () =>
      getDataUrls({
        id,
        eleccion,
        page,
        nomenclator,
        idHistorico,
        parentLevel,
        mesa,
      }),
    [id, eleccion, page, nomenclator, idHistorico, parentLevel, mesa]
  );

  const setPage = useSetPage();
  useEffect(() => {
    setPage(dataUrls, initialUrlInfo);
  }, [dataUrls, initialUrlInfo, setPage]);

  const dispatchNotifications = useDispatchNotifications();
  if (idHistorico != null) {
    dispatchNotifications({ type: actionTypes.unsuscribe });
  }

  return null;
};
export default DataFetcher;
